<template>
    <div :class="['main-content-article', 'article_'+article.id] ">
        <div v-html="article.text"></div>
    </div>
</template>

<script>
import content from "@/assets/content.json"
export default {
    data() {
        return {
            article: {
                id: null,
                title: null,
                alias: null,
                text: null
            }
        }
    },
    watch: {
        $route(to, from) {
            let args = core.getPathArgs(["id"])
            this.article = content.find(item => item.id == args.id);
            
        }
    },
    mounted() {
        let args = core.getPathArgs(["id"])
        if(args.id === undefined){
            args.id=5;
        }
        this.article = content.find(item => item.id == args.id)
    }
}
</script>

<style lang="scss" scoped>
.main-content-article{
    max-width: 900px;
    margin: auto
}
</style>